import React, {useEffect} from 'react'
import styles from './styles.css'
import {Form, Field} from 'simple-react-form'
import cloneDeep from 'lodash/cloneDeep'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Phone from 'App/components/fields/Phone'
import Place from 'App/components/fields/Place'

export default function Points(props) {
  useEffect(() => {
    if (!props.value || props.value.length < 2) {
      props.onChange([{}, {}])
    }
  })
  if (!props.value) return null
  return (
    <div className={styles.container}>
      {props.value.map((point, index) => {
        const onChange = changes => {
          const newValue = cloneDeep(props.value)
          newValue[index] = changes
          props.onChange(newValue)
        }
        return (
          <div key={index}>
            <Form state={point} onChange={onChange} useFormTag={false}>
              <Field fieldName="name" type={Text} label="Nombre de la ubicación" />
              <Field fieldName="placeId" type={Place} label="Dirección" />
              <Field fieldName="addressLine2" type={Text} label="Dpto, num u otro" />
              <Field fieldName="instructions" type={Text} label="Instrucciones" />
              <Field fieldName="phone" type={Phone} label="Teléfono si es que hay problemas" />
            </Form>
            <pre>{JSON.stringify(point, null, 2)}</pre>
          </div>
        )
      })}
    </div>
  )
}
